export default {
    // https://docs.amplify.aws/vue/build-a-backend/auth/use-existing-cognito-resources/#use-auth-resources-without-an-amplify-backend
    Auth: {
        Cognito: {
            region: import.meta.env.VITE_COGNITO_REGION,

            userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,

            userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,

            signUpVerificationMethod: 'code', // 'code' or 'link'

            allowGuestAccess: false,
        }
 
    }
  }